
import {withLatestFrom, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CustomersApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { CAAction } from '../actions';
import { CustomerTeam } from '../actions/index';
import * as selectors from '../reducers/index';

const of = Observable.of;

@Injectable()
export class CustomerTeamEffects {
  @Effect()
  fetchCustomerTeam = this.actions$
    .ofType(CustomerTeam.REQUEST_ALL).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
    switchMap(([action, id]) =>
      this.customerApi
        .listTeam(id)
        .map(res => CustomerTeam.ResponseSuccessAllAction(res))
        .catch(err => of(CustomerTeam.ResponseFailAllAction(err)))
    ),);

  @Effect()
  addTeam = this.actions$
    .ofType(CustomerTeam.REQUEST_CREATE).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
    switchMap(([action, id]) =>
      this.customerApi
        .addTeam(id, action.payload.staff.id, action.payload.role)
        .map(res => CustomerTeam.ResponseSuccessCreateAction(res))
        .catch(err => of(CustomerTeam.ResponseFailCreateAction(err)))
    ),);

  @Effect()
  removeTeam = this.actions$
    .ofType(CustomerTeam.REQUEST_REMOVE).pipe(
    withLatestFrom(this.store.select(selectors.getSelectedId('customers'))),
    switchMap(([action, id]) =>
      this.customerApi
        .removeTeam(id, action.payload.id)
        .map(res => CustomerTeam.ResponseSuccessRemove({ id: action.payload.id, customerId: id }))
        .catch(err => of(CustomerTeam.ResponseFailRemove(err)))
    ),);

  constructor(
    private store: Store<any>,
    private actions$: Actions<CAAction>,
    private customerApi: CustomersApi
  ) {}
}
